import './js/src/functions';
import './js/src/modules';
import './js/src/header';
import './js/src/modals';
import './js/src/forms';
import './js/src/cookies';

document.addEventListener('DOMContentLoaded', () =>
  global.modules.init()
);

// css
import './css/common.css';
import './components/breadcrumbs.css';
import './components/tags.css';
import './components/blog_highlights.css'
import './components/join_newsletter.css';
import './components/category.css';